import { functions } from '@/firebase'
import { usersMetaData } from './index'

const sendInvite = async (email: string) => {
	const send = functions.httpsCallable('invites_create')

	const result = await send({ email })

	return result.data
}

const resendInvite = async (email: string) => {
	const send = functions.httpsCallable('invites_resend')

	const result = await send({ email })

	return result.data
}

const deleteInvite = async (email: string) => {
	const del = functions.httpsCallable('invites_delete')

	const result = await del({ email })

	return result.data
}

interface PendingInvite
{
	email: string
	createdAt: firebase.firestore.Timestamp
}

const pendingInvitesForUser = async (userId: string) => {
	const ref = usersMetaData.doc(userId).collection('invites')
	const snap = await ref.get()

	if (snap.empty)
	{
		return []
	}

	return snap.docs.map(doc => {
		const email = doc.id
		const data: PendingInvite = doc.data() as PendingInvite

		data.email = email

		return data
	})
}

export {
	sendInvite,
	resendInvite,
	deleteInvite,
	pendingInvitesForUser
}
